"use client";

import * as LucideIcons from "lucide-react";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils/cn";

interface DynamicIconProps {
  icon: string;
  className?: string;
  style?: React.CSSProperties;
}

export function DynamicIcon({ icon, className, style }: DynamicIconProps) {
  // SVG string kontrolü
  if (icon.startsWith("<svg")) {
    return (
      <span
        className={cn("icon-svg w-6 h-6", className)}
        dangerouslySetInnerHTML={{ __html: icon }}
      />
    );
  }

  // Lucide icon kontrolü
  const Icon = (LucideIcons[icon as keyof typeof LucideIcons] ||
    LucideIcons.Code2) as LucideIcon;
  return <Icon className={cn("w-6 h-6", className)} style={style} />;
}
